import { Box } from "@mui/material";
import {
  FONT_DISPLAY,
  FONT_UI,
} from "@/src/components/common/broadsheet/tokens";

const TORN_EDGE =
  "M0 0 L18 7 L36 0 L54 8 L72 1 L90 9 L108 2 L126 10 L144 3 L162 9 L180 1 L198 8 L216 2 L234 9 L252 1 L270 7 L288 0 L306 8 L324 2 L342 9 L360 3 L360 16 L0 16 Z";

export default function ErrorMark({
  code,
  label,
}: {
  code: string;
  label: string;
}) {
  return (
    <Box
      component="svg"
      viewBox="0 0 360 260"
      role="img"
      aria-label={`${code} — ${label}`}
      sx={{
        display: "block",
        width: "100%",
        maxWidth: "22rem",
        height: "auto",
        mx: "auto",
      }}
    >
      <rect
        x="0.5"
        y="0.5"
        width="359"
        height="243"
        fill="var(--bf-newsprint-raised)"
        stroke="var(--bf-rule)"
      />

      <text
        x="24"
        y="30"
        style={{
          fontFamily: FONT_UI,
          fontSize: "10px",
          fontWeight: 700,
          letterSpacing: "1.6px",
        }}
        fill="var(--bf-kicker)"
      >
        BRIEFLANDS
      </text>
      <text
        x="336"
        y="30"
        textAnchor="end"
        style={{
          fontFamily: FONT_UI,
          fontSize: "10px",
          fontWeight: 700,
          letterSpacing: "1.6px",
        }}
        fill="var(--bf-kicker)"
      >
        {label.toUpperCase()}
      </text>

      <line
        x1="24"
        y1="42"
        x2="336"
        y2="42"
        stroke="var(--bf-ink)"
        strokeWidth="1"
      />
      <line
        x1="24"
        y1="45"
        x2="336"
        y2="45"
        stroke="var(--bf-ink)"
        strokeWidth="1"
      />

      <text
        x="180"
        y="146"
        textAnchor="middle"
        style={{
          fontFamily: FONT_DISPLAY,
          fontSize: "92px",
          fontWeight: 700,
        }}
        fill="var(--bf-ink)"
      >
        {code}
      </text>

      <line x1="24" y1="168" x2="336" y2="168" stroke="var(--bf-rule)" />

      <g fill="var(--bf-rule)">
        <rect x="24" y="182" width="136" height="4" />
        <rect x="24" y="194" width="136" height="4" />
        <rect x="24" y="206" width="96" height="4" />
        <rect x="200" y="182" width="136" height="4" />
        <rect x="200" y="194" width="112" height="4" />
        <rect x="200" y="206" width="136" height="4" />
      </g>

      <line x1="180" y1="178" x2="180" y2="214" stroke="var(--bf-rule)" />

      <rect x="24" y="120" width="5" height="26" fill="var(--bf-spine-teal)" />
      <rect x="331" y="120" width="5" height="26" fill="var(--bf-spine-gold)" />

      <g transform="translate(0 228)">
        <path d={TORN_EDGE} fill="var(--bf-newsprint)" />
      </g>
    </Box>
  );
}
